import { trackEvent } from "@components/Various/Analytics/gtag";
import MutedText from "@components/Various/MutedText";
import { LoadingOverlay, Modal, TextInput } from "@mantine/core";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
import { Mail, User } from "react-feather";
import BrandButton from "../../Various/BrandButton";
import ApplicationFile from "./ApplicationFile";
import useApplicationForm from "./useApplicationForm";

function SendApplication({
  isOpen,
  jobId,
  close,
}: {
  isOpen: boolean;
  jobId: string;
  close: () => void;
}) {
  const { t } = useTranslation("joblisting");
  const { form, file, setFile, submit, fileError, status } = useApplicationForm(
    jobId,
    close
  );

  return (
    <Modal opened={isOpen} onClose={close} title={t("sendApplication.title")}>
      <div className="relative">
        <LoadingOverlay visible={status.isSubmitting} />

        <form onSubmit={submit} data-test="application-form">
          <TextInput
            placeholder="mail@example.com"
            label={t("sendApplication.yourEmailAddress")}
            mt="lg"
            required
            icon={<Mail size={15} />}
            type="email"
            {...form.getInputProps("email")}
          />

          <TextInput
            placeholder={t("sendApplication.namePlaceholder")}
            label={t("sendApplication.yourName")}
            mt="lg"
            required
            icon={<User size={15} />}
            {...form.getInputProps("name")}
          />

          <TextInput
            placeholder="https://linkedin.com/in/max.mustermann"
            label={t("sendApplication.yourLinkedInProfile")}
            mt="lg"
            icon={<User size={15} />}
            type="url"
            {...form.getInputProps("linkedIn")}
          />

          <ApplicationFile
            file={file}
            setFile={(e) => {
              trackEvent({
                action: "select_application_file",
                category: "job_application",
                label: jobId,
              });

              setFile(e);
            }}
            hasError={fileError}
          />

          <BrandButton type="submit" mt="lg" mb="sm">
            {t("sendApplication.submitButton")}
          </BrandButton>

          <MutedText>
            Mit dem Absenden Ihrer Bewerbung stimmen Sie unseren{" "}
            <Link href="/legal/privacy" className="underline">
              Datenschutzbestimmungen
            </Link>{" "}
            und{" "}
            <Link href="/legal/terms" className="underline">
              Nutzungsbedingungen
            </Link>{" "}
            zu.
          </MutedText>
        </form>
      </div>
    </Modal>
  );
}

export default SendApplication;
